import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { catchError, map } from 'rxjs/operators';
import { NbToastrService } from "@nebular/theme";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";

@Injectable()
export class WSErrorInterceptor implements HttpInterceptor {

  pathBaseTranslate: string = 'general.ws-error-interceptor';

  constructor(
    private toastrService: NbToastrService,
    private router: Router,
    private translateService: TranslateService
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const excludesUrl = req.url.includes("assets");

    return next.handle(req).pipe(
      map((event: HttpEvent<any>) => {
        return event;
      }),
      catchError((err: any) => {
        if (err instanceof HttpErrorResponse) {
          if (!excludesUrl) {
            if (err.status === 401) {
              console.log(err);
              if (req.url.indexOf("/login") !== -1) {
                this.toastrService.warning(
                  err.error?.message,
                  this.getTranslate(`${this.pathBaseTranslate}.titleWarning`)
                );
              } else {
                this.toastrService.warning(
                  err.error?.message,
                  this.getTranslate(`${this.pathBaseTranslate}.titleWarning2`)
                );
                this.router.navigateByUrl("logout");
              }
            } else if (
              err.statusText === "OK" &&
              err.status === 406 &&
              err.url.includes("comment")
            ) {
              this.toastrService.warning(
                err.error.message,
                this.getTranslate(`${this.pathBaseTranslate}.titleWarning3`)
              );
            } else if (
              err.status === 406 &&
              err.error !== undefined &&
              err.error.message !== undefined
            ) {
              this.toastrService.danger(
                err.error.message,
                this.getTranslate(`${this.pathBaseTranslate}.titleError`)
              );
            } else {
              this.toastrService.danger(
                this.getTranslate(`${this.pathBaseTranslate}.messageError`),
                this.getTranslate(`${this.pathBaseTranslate}.titleError`)
              );
            }
          }
        } else {
          this.toastrService.danger(
            this.getTranslate(`${this.pathBaseTranslate}.messageError`),
            this.getTranslate(`${this.pathBaseTranslate}.titleError`)
          );
        }
        return throwError(err);
      })
    );
  }

  getTranslate(key: string): string {
    let translation: string;
    this.translateService.get(key).subscribe((text: string) => {
      translation = text;
    });
    return translation;
  }
}
